import { client } from '../client';

export interface Activity {
  activityName: string;
  activityId?: number;
  activityType?: ActivityTypes;
}

export enum ActivityTypes {
  Project = 'PROJECT',
  NonProject = 'NON_PROJECT',
}

const get = (type: ActivityTypes): Promise<Activity[]> =>
  client.get<Activity[]>(`/timesheets/activity?type=${type}`);

const create = (payload: {
  activityName: string;
  type: ActivityTypes;
}): Promise<void> => client.post('/timesheets/activity', payload);

const remove = (activityId: number): Promise<void> =>
  client.delete(`/timesheets/activity/${activityId}`);

export const ActivitiesApi = {
  get,
  create,
  remove,
};
